<template>
  <nav
      class="top-0 fixed z-50 w-full flex flex-wrap items-center justify-between px-2 py-3 navbar-expand-lg bg-white shadow"
  >
    <div
        class="container px-4 mx-auto flex flex-wrap items-center justify-between"
    >
      <div
          class="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start"
      >
        <!--        <router-link to="/">-->
        <!--          <a-->
        <!--              class="text-blueGray-700 text-sm  font-bold leading-relaxed inline-block mr-4 py-2 whitespace-nowrap"-->
        <!--              style="font-size:18px"-->
        <!--              href="#pablo"-->
        <!--          >-->
        <!--            RE-Aging-->
        <!--          </a>-->
        <!--        </router-link>-->
        <button
            class="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
            type="button"
            v-on:click="setNavbarOpen"
        >
          <i class="fas fa-bars"></i>
        </button>
      </div>
      <div
          class="lg:flex flex-grow items-center"
          :class="[navbarOpen ? 'block' : 'hidden']"
          id="example-navbar-warning"
      >
        <ul class="flex flex-col lg:flex-row list-none mr-auto">
          <li class="flex items-center">
            <router-link
                class="hover:text-blueGray-500 text-blueGray-700 px-3 py-2 flex items-center text-xs uppercase font-bold"
                to="/"
                style="font-size:20px"
            >
              <i class="bi bi-house me-1"></i>
              Home
            </router-link>
          </li>
        </ul>
        <ul class="flex flex-col lg:flex-row list-none lg:ml-auto">
          <li class="flex items-center">
            <router-link
                class="hover:text-blueGray-500 text-blueGray-700 px-3 py-2 flex items-center text-lg uppercase font-bold"
                to="/geneinfo"
                style="font-size:14px">
              Gene
            </router-link>
          </li>
          <li class="flex items-center">
            <router-link
                class="hover:text-blueGray-500 text-blueGray-700 px-3 py-2 flex items-center text-lg uppercase font-bold"
                to="/co_expression"
                style="font-size:14px">
              Co-expression
            </router-link>
          </li>
          <li class="flex items-center">
            <router-link
                class="hover:text-blueGray-500 text-blueGray-700 px-3 py-2 flex items-center text-lg uppercase font-bold"
                to="/singlecellinfo"
                style="font-size:14px">
              Single Cell
            </router-link>
          </li>
          <li class="flex items-center">
            <router-link
                class="hover:text-blueGray-500 text-blueGray-700 px-3 py-2 flex items-center text-lg uppercase font-bold"
                to="/tutorial"
                style="font-size:14px">
              Contact Us
            </router-link>
          </li>
          <li class="flex items-center">
            <router-link
                to="/download">
              <button
                  class="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none lg:mr-1 lg:mb-0 ml-3 mb-0 ease-linear transition-all duration-150"
                  type="button"
              >
                <i class="fas fa-arrow-a  lt-circle-down"></i> Download
              </button>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>

export default {
  data() {
    return {
      navbarOpen: false,
    };
  },
  methods: {
    setNavbarOpen: function () {
      this.navbarOpen = !this.navbarOpen;
    },
  },
  components: {
  },
};
</script>
